import { createEDSTheme } from '@ellucian/react-design-system/core/themes';
import ctaColors from '@ellucian/react-design-system/core/themes/common/ctaColors';
import find from 'lodash/find';
const parseTheme = theme => {
    if (!theme) {
        return createEDSTheme('light');
    }
    const { color1, color2, color3: base } = theme;
    const ctaColor = find(ctaColors, it => it.base.toUpperCase() === base.toUpperCase());
    return createEDSTheme('light', {
        palette: {
            ctaColor,
            primary: {
                main: color1,
            },
            secondary: {
                main: color2,
            },
        },
    });
};
export default parseTheme;
